<template>
  <v-layout class="page_list"  >
    <div v-if="dialog">
         <div class="text-xs-center">
         <v-dialog
            v-model="dialog"
            hide-overlay
            persistent
            width="300"
          >
               <v-card
                  color="primary"
                  dark
                >
                  <v-card-text>
                    Please stand by
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
              </v-card>      
          </v-dialog>
       </div>
    </div>
    <div v-else style="width:100%">
      <v-flex xs12 v-if="total_record1 > 0">
      <!--   <div class="col-12 p-l-0 p-r-0" style="background: #fff;">
           <ul class="search-listing">
              <li  v-for="(item, index) in camlist">
                  <a  v-on:click.capture='goToDetail(item.id )'>
                  <h4 class="card-title">
                   <span class="card-title font-blue-l cusfont16px"> <country-flag country='fr' size='normal' v-bind:class="cnflag(item.country)"/> ({{item.id}}) {{item.name}}
                   
                </span></h4>
                  <h6 class="card-subtitle mb-2 text-muted">{{item.sales_person_name}}</h6>
                  <p class="card-text text-success"><span id="lblStatus"  v-bind:style="{color:filteredData(item.status)}" v-model="item.status"> {{filteredStatusValue(item.status)}}</span></p> </a>
                  <p class="card-text text-muted">{{item.start_date | format_date }} - {{item.end_date | format_date}} {{item.totalday}}</p>
                 
              </li>
            </ul>
         </div>  -->
         <div class="card m-b-10" v-for="(item, index) in camlist">
           <div class="card-body-l">

              <a v-on:click.capture='goToDetail(item.id )'>
                 <h6 class="card-subtitle mb-2 text-muted" v-if="item.agency_name">{{item.agency_name}}</h6>

                
                  
                    <span class="card-title font-blue-l cusfont16px box1 fix" style="">
                      <i class="flag-icon" title="my" id="my" v-bind:class="cnflag(item.country)"></i>  ({{item.id}}) {{item.name}}
                       
                     <!-- <country-flag country='fr' size='normal' v-bind:class="cnflag(item.country)"/>  -->

                    </span>
                
                <h6 class="card-subtitle text-muted" v-if="item.sales_person_name">{{item.sales_person_name}} </h6>
                <p class="card-text text-success cusfont16px"><span id="lblStatus"  v-bind:style="{color:filteredData(item.status)}" v-model="item.status"> {{filteredStatusValue(item.status)}}</span></p>
              </a>
              <p class="card-text cusfont16px font-blue">{{item.start_date | format_date }} - {{item.end_date | format_date}} {{item.totalday}}</p>
           </div>
          
        </div>
         <div class="card m-b-10" v-if="showPage==true && total_page1 > 1">
          <div class="card-body-l"  >
              <div class="text-center  paging-title" v-if="!isPage">
                 <a @click="pageChangeHandle(total_record1)" class="txt-al" > Load More </a>
              </div>
              <div class="text-center  pt-2  paging-title"  v-else>
                 <v-progress-linear :indeterminate="true" class="loadingpbar "></v-progress-linear>
              </div>
          </div>
        </div>
      </v-flex>
     <!--  <div v-if="total_record1 > 0" class="col-12" >
    <! <v-card  > -->
        
      
     <!--  </div>  -->
    
         <div v-else>
            <div  class="card m-b-10">
              <div class="card-body"> 
                <div  class="card-title text-center" style="width:355px;font-size: 16px;">No data found</div>
              
              </div>
            </div>
         </div>
      <!--  
     <v-flex xs12 class="text-xs-left card mb-1" v-else>
         <v-card flat class="txcenter card-body">
            No data found
         </v-card>
     </v-flex> -->

     <v-flex>
        <v-btn bottom right fab dark  color="primary btn_floading"  @click.stop="drawer = !drawer" style="z-index:12">
          <v-icon dark>search</v-icon>
      </v-btn>    
    </v-flex>
     <v-flex>
       <div id="paging" style="color:#acadae; font-size:14px; font-style:italic; text-align:left;">
         Showing {{startPage}} to {{endPage}} of {{total_record1}} entries
        </div>
     </v-flex>
   </div>
	 <div class="text-xs-center">
         <v-dialog
            v-model="dialogsearch"
            hide-overlay
            persistent
            width="300"
          >
               <v-card
                  color="primary"
                  dark
                >
                  <v-card-text>
                    Please stand by
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
              </v-card>      
          </v-dialog>
       </div>
    <v-navigation-drawer
        v-model="drawer"
        right
        
        temporary
        hide-overlay

        class="right-sidebar shw-rside"
      >
      <div class="slimscrollright">
          <div class="rpanel-title"> Filter <span> <v-icon dark class="right-side-toggle" @click="drawer = false">close</v-icon> 
            </span> </div>
                <div class="r-panel-body">
                   <form method="post" class="form-material m-t-20"  style="margin-top:10px" v-on:submit="searchAction">
                      <div class="form-group m-b-40" id="nformat">
                        <label for="input1">Name or ID</label>
                        <input type="text" class="form-control" id="input1" name="name" v-model="name" style="width: 100%;" >
                      </div>
                      <div class="form-group" id="nformat">
                        <label for="input8">Schedule</label>
                        <input readonly v-model="daterange" class="form-control input-daterange-datepicker" type="text" id="daterange" name="daterange" style="width: 100%; background-color:white" @click="openTestDialog($event)"/>
                        <Date-search-dialog v-model="date_filter" 
                           
                            @dateWasReset="doget2dates($event)"
                             ref="form1"
                             />
                      </div>
                      
                      <div class="form-group" id="nformat">
                        <label for="input2">Advertiser</label>
                        <input  v-model="advertiser" name="advertiser" type="text" class="form-control" id="input2" style="width: 100%;" >
                      </div>
                      <div class="form-group" id="nformat">
                        <label for="input3">Agency</label>
                        <input v-model="agency" name="agency" type="text" class="form-control" id="input3" style="width: 100%;">
                      </div>
                      <div class="form-group" id="nformat">
                        <label for="input4">Salesperson</label>
                        <input v-model="salesperson" name="salesperson" type="text" class="form-control" id="input4" style="width: 100%;">
                      </div>
                      <div class="form-group" id="nformat">
                        <label for="input6">Status</label>
                            
                          <v-combobox
                              v-model="status"
                              :items="statusItems"
                              item-value='value'
                              item-text='text'
                              return-object
                              
                             autocomplete
                           ></v-combobox>
                     
                      </div>
                      <div class="form-group" id="nformat">
                        <label for="input7">Country</label>
                         <v-select
                              v-model="country"
                            :items="countryItems"
                            item-value='value'
                              item-text='text'
                            single-line
                          ></v-select>
                      
                      </div>
                                                 
                      <v-spacer></v-spacer>
                     
                        <v-btn type="submit" color="info" class="btn vbtn-cus waves-effect waves-light btn-info" @click="searchAction">Apply</v-btn>
                       <v-btn  type="button" color="white"  class="btn vbtn-cus waves-effect waves-light btn-secondary" @click="reset">Reset</v-btn>
                                                    
                </form>                  
              </div>
            </div>
        </div>
       
      </v-navigation-drawer>
  </v-layout>
     
</template>
<style scoped>

  html body .m-b-10{
        margin-bottom: 0px !important;
  }
  .v-text-field {
    padding-top: 0px !important;
    margin-top: 0px !important;
}
  #nformat input {
      padding: 0px 10px 5px 0 !important;
      width: 100% !important;
  }
  .page_list{
      /*max-width: 407px;*/
    
      word-break: break-all !important;
     /* word-break: break-word !important;*/
      white-space: normal;
  }
  .card-subtitle {
        margin-top: 10px;
  }
  .row{
    width: 100%;
  }
  .txcenter{
    text-align: center;
  }
  .search-listing{
      padding: 0px !important;
      margin-top: -19px !important;
  }
  .layout.row{
      margin-bottom: 10px;
  }
  .v-btn .v-btn__content .v-icon {
  
    padding: 15px !important;
}
  .btn_floading{
          position: fixed;
          bottom: 20px;
          right: 20px;
   
    }
    .v-btn--floating{
      border-radius: 50% !important;  
    }
   .vbtn-cus {
     min-width: 58px;
      text-transform: capitalize !important;
      height: 36px;
      border-radius: 3px ;
      font-size: 15px;
  }
  .card-title{
   /* margin-bottom: -0.25rem !important;*/
        line-height: 22px !important;
      display: inline-block;
      height: auto;
  }
  .card-text{
    margin-top: 10px;
  }
  .box1 {
    height: 20%;
  

    margin-right: 7px;
    text-align:left;
}
/*Important CSS*/
.box1{
      padding-top: 10px;
  /*  font-size:1em;*//*Set a font size*/
}
.box1:before {/*add a pseudo element*/
    content:"";
    display:block;
    height:50%;
    width:100%;
    margin-top:-0.5em;/*half of the font size*/
}
.fix:before {
    margin-top:-1em !important;/*half of the font size X the number of lines*/
}
</style>
<script>
  import { loginService } from '@/components/_service/Users.js'
  import { StatusColor,CurrencyCode,StatusValue,country } from '@/components/_service/Config.js'
  import CountryFlag from 'vue-country-flag'
 
  import DateSearchDialog from '@/components/DateSearchDialog';
  export default {
      name: 'List',
      components: {
          CountryFlag,
          DateSearchDialog
      },
      data: () => ({
//loading:true,
          act:"",
          search:[],
          activeColor:"#F90648",
          status:"",
          stValue:"",
          country:"flag-my",
          total_page: 0,
          currentPage: 0,
          page_length:10,
          total_record:0,
          startRecord:0,
          //start_num:0,
          max_page:10,
          showPage:true,
          queue: [],
          lists:[],
          isPage:false,
          dialogsearch: false,
          dialog: false,
          drawer: null,

          name:null,
          daterange:null,
          advertiser:null,
          agency:null,
          salesperson:null,

          date_filter:false,
          sdate:null,
          edate:null,
          
          statusItems:[ {value:"approve",
                        text:"Approved"},
                        {value:"disapprove",
                        text:"Not Approved"},
                        {
                         value:"waiting_approval",
                         text:"Waiting For Approval"},
                        {
                         value:"lead",
                         text:"Lead"},
                        {
                         value:"proposed_10",
                         text:"Proposed - 10%"},
                        {
                          value:"proposed_50",
                          text:"Proposed - 50%"},
                        {
                           value:"proposed_90",
                           text:"Proposed - 90%"},
                        {
                           value:"lost",
                           text:"Lost"
                         },
                      ],
           status: [],
           country:[]

          //start_record:0
        }),
      

      async mounted(){
      
        await this.getCampainList();
        this.dialog = this.$store.state.isLoading;
        this.act = this.$route.query.act;
       // console.log(this.act);
                  
      },
      computed:{
        countryItems(){
         
          var jsonObj = [];
          for(const key in country){
              jsonObj.push({text: country[key],
                            value:key})    
          }
          return jsonObj;
        },
         camlist(){
           return this.lists = this.$store.getters.loadCamlist;
         },
         total_record1(){
          // console.log( this.$store.getters.loadCamTotalRecord)
           return this.total_record =  this.$store.getters.loadCamTotalRecord;
         },   
         total_page1 (){
           return Math.ceil(this.$store.getters.loadCamTotalRecord/this.page_length);
             
         },     
          page_length1(){
           return  this.$store.getters.loadPageLength;
         },  
         //////////////////////////////////////////////
         startPage() {
             const  start_num = this.currentPage + 1; 
             const totalpage =Math.ceil(parseFloat(this.$store.getters.loadCamTotalRecord)/parseFloat(this.page_length));         
            // When on the first page
          //  console.log(this.currentPage)
             if ((( this.currentPage * this.page_length) +1) < this.$store.getters.loadCamTotalRecord){
                  return (this.currentPage*this.page_length)+1;
             }else{
                 return this.$store.getters.loadCamTotalRecord
             }
          
         },
         endPage(){
            const  start_num =  this.currentPage + 1;
          //  console.log("start_num" + start_num);
            //console.log("(start_num * this.page_length " + (start_num * this.page_length ));
            return (start_num * this.page_length > this.$store.getters.loadCamTotalRecord) ? this.$store.getters.loadCamTotalRecord : (start_num * this.page_length)
         },
             
        

      },
      

      created(){
         //console.log(this.$store.state.isLoading)
        
       
      },
      watch: {
        dialogsearch (val) {
         
           if (this.$store.getters.loadCamTotalRecord <= 20){
             this.dialogsearch = false
           }else if (!val)  return
             setTimeout(() => (this.dialogsearch = false), 1000)
           //setTimeout(function () { this.checkDialog(this.$store.getters.loadCamTotalRecord) }.bind(this), 10000)
          
        },
        dialog (val) {
          if (!val) return
              setTimeout(() => (this.dialog = false), 6000)
          }
      },
     
      methods:{
          
          checkDialog($campaigntotal){
            if ($campaigntotal == 0) {
               this.dialogsearch = false
            }else{
               this.dialogsearch = true
            }
          },
          getCampainList(){
         
            this.search={page:this.currentPage}
            this.$store.commit('loading',true)
            this.$store.dispatch('camlist', this.search);
          },
         
          searchAction(e){
            //console.log(e);
              setTimeout(() => {
                    this.dialogsearch = true;
              },3000) 
     
             this.currentPage =0;
            if (this.$store.state.isLoading){
              this.showPage = false
            }
            
              this.search={

                name:this.name,
                daterange:this.daterange,
                advertiser:this.advertiser,
                agency:this.agency,
                salesperson:this.salesperson,
                status:this.status.value,
                country:this.country,
                page:this.currentPage
              }
                          
              this.$store.dispatch('camSearch', this.search);
              
              this.dialogsearch = false;
              //this.$router.push({ path: `/campaign` })

               this.drawer=false 
               e.preventDefault();
             // console.log(this.search)
              //return false;

          },
          reset(){      
              this.name= null;
              this.daterange=null;
              this.advertiser= null;
              this.agency = null;
              this.salesperson=null;
              this.status =[];
              this.country =[];
              return false
          },  
          pageChangeHandle(total_record){
              
            
              this.total_record = total_record;
             // this.currentPage = this.start_num;
              this.total_page = (Math.ceil(parseFloat(this.total_record)/parseFloat(this.page_length))-1)
             // console.log("this.currentPage" + this.currentPage)
              //console.log("this.total_page" + this.total_page)
           //   console.log( this.total_page)
              if ( this.currentPage <=   this.total_page){
                this.currentPage  += 1
              }
              
              this.isPage = true

             this.search={

                name:this.name,
                daterange:this.daterange,
                advertiser:this.advertiser,
                agency:this.agency,
                salesperson:this.salesperson,
                status:this.status.value,
                country:this.country,
                page:this.currentPage
              }
              
             // console.log(this.search)
               loginService.camlist( this.search ).then((data)=>{
                    this.page_length = data['page_length']
                    this.total_record = data['total_record']
                    //this.start_record = data['start_record']
                    this.lists.push(...data[0])
                    setTimeout(() => {
                      this.isPage = false
                      //console.log(this.startPage)
                     // console.log( this.currentPage)
                      //console.log(this.total_page)
                       if (this.currentPage == this.total_page ){
                          this.showPage = false
                       }
                    },2000)      
               });
              
         }, 
         doget2dates(e){
            this.daterange = e[0] + " - " + e[1]
         },
          openTestDialog (e) {
              this.date_filter =true;

          },     
          filteredData(status){
            let statusValue=""
            Object.keys(StatusColor).forEach(key => {
              const item =  StatusColor[key]
            
              if (status == key){
                statusValue = item
              }
            })  
            return statusValue;
        },
      
       filteredStatusValue(status){
            let statusKey=""
            Object.keys(StatusValue).forEach(key => {
              const item =  StatusValue[key]
            
              if (status == key){
                statusKey= item
              }
            })  
            return statusKey;
         },   
        cnflag(item){
            let country;
            if(item){
                country = "flag-icon-"+item.toLowerCase();
            }
            return country;                    
                      
        },
        goToDetail(camid){
          this.$router.push({ name: 'detail', params: { id: camid ,flightid:0 }})
        
        },
              
      },
    
	}
  </script>